// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./html2pdf.js.d.ts" />
import type { PdfOptions } from './types';

/**
 * Captures `element` as a PDF and triggers a browser download.
 *
 * `html2pdf.js` is loaded on-demand via a dynamic import — it contributes zero
 * bytes to the initial bundle.
 *
 * @param element - The DOM element to capture.
 * @param options - PDF generation options.
 */
export async function downloadPdfFromElement(
  element: HTMLElement,
  options: PdfOptions = {},
): Promise<void> {
  const mod = await import('html2pdf.js');
  // CJS interop: some bundlers expose the callable as .default, others as the module root
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-unnecessary-condition
  const html2pdf = (mod.default ?? mod) as typeof mod.default;

  const {
    fileName = 'document',
    margin = 10,
    pageSize = 'a4',
    orientation = 'portrait',
    scale = 2,
    html2canvas: html2canvasOptions,
    jsPDF: jsPDFOptions,
  } = options;

  await html2pdf()
    .set({
      margin,
      filename: fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale, useCORS: true, ...html2canvasOptions },
      jsPDF: { unit: 'mm', format: pageSize, orientation, ...jsPDFOptions },
    })
    .from(element)
    .save();
}
